import {
  Color,
  FontWeight,
  ScreenSize,
} from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiFaqComponent' })(
  ({ brandType, breakpoints, type, brandColors, typography }) => ({
    title: {
      color: brandColors.primaryMain,
      ...type['44_medium'],
      textWrap: 'pretty',
      marginLeft: typography.pxToRem(36),
      marginRight: typography.pxToRem(36),
      marginBottom: typography.pxToRem(105),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...brandType['heading-xxs'],
        marginBottom: typography.pxToRem(48),
        marginTop: typography.pxToRem(48),
        marginLeft: typography.pxToRem(24),
        marginRight: typography.pxToRem(24),
      },
    },
    titleLabel: {
      color: brandColors.primaryMain,
      ...type['16_medium'],
      marginLeft: typography.pxToRem(36),
      marginRight: typography.pxToRem(36),
      marginBottom: typography.pxToRem(8),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['16_medium'],
        marginLeft: typography.pxToRem(24),
        marginRight: typography.pxToRem(24),
      },
    },
    root: {
      border: 'none',
      boxShadow: 'none',
      borderBottom: `1px solid ${Color.BLACK_15}`,
      '&:last-child': {
        borderBottom: 'none',
      },
      backgroundColor: Color.PRIMARY_BLUE_LIGHTEST,
      '&::before': {
        height: '0px',
      },
    },
    faqQuestion: {
      color: brandColors.primaryMain,
      ...type['24_medium'],
      marginBottom: '0px',
      [breakpoints.up(ScreenSize.MEDIUM)]: {
        padding: `${typography.pxToRem(28)} 0 ${typography.pxToRem(
          28
        )} ${typography.pxToRem(40)}`,
      },
      [breakpoints.up(ScreenSize.LARGE)]: {
        padding: `${typography.pxToRem(28)} 0 ${typography.pxToRem(
          28
        )} ${typography.pxToRem(36)}`,
      },
    },
    faqQuestionNested: {
      textDecoration: 'underline',
      padding: '0 !important',
    },
    faqQuestionContainer: {
      minHeight: typography.pxToRem(132),
      height: 'auto',
      borderWidth: '0.5px 0px 0px 0px',
      borderStyle: 'solid',
      borderColor: brandColors.primaryMain,
    },
    faqQuestionContainerNoBorder: {
      borderStyle: 'none',
      p: {},
    },
    detailsPanel: {
      padding: `${typography.pxToRem(28)} ${typography.pxToRem(
        24
      )} ${typography.pxToRem(28)} ${typography.pxToRem(24)}`,
      minHeight: typography.pxToRem(132),
      [breakpoints.up(ScreenSize.MEDIUM)]: {
        padding: `${typography.pxToRem(28)}  0 ${typography.pxToRem(
          28
        )} ${typography.pxToRem(40)}`,
      },
      [breakpoints.up(ScreenSize.LARGE)]: {
        padding: `${typography.pxToRem(28)}  0 ${typography.pxToRem(
          28
        )} ${typography.pxToRem(36)}`,
      },
    },
    detailsPanelNoPadding: {
      padding: `${typography.pxToRem(28)} ${typography.pxToRem(
        24
      )} ${typography.pxToRem(28)} ${typography.pxToRem(0)}`,
      minHeight: typography.pxToRem(132),
      [breakpoints.up(ScreenSize.MEDIUM)]: {
        padding: `${typography.pxToRem(28)}  0 ${typography.pxToRem(
          28
        )} ${typography.pxToRem(0)}`,
      },
      [breakpoints.up(ScreenSize.LARGE)]: {
        padding: `${typography.pxToRem(28)}  0 ${typography.pxToRem(
          28
        )} ${typography.pxToRem(0)}`,
      },
    },
    icons: {
      color: brandColors.primaryMain,
      width: '32px',
      height: '32px',
    },
    viewMoreWrapper: {
      padding: '4.5rem 0.625rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [breakpoints.down(ScreenSize.SMALL)]: {
        padding: '2rem',
      },
    },

    viewMore: {
      color: brandColors.primaryMain,
      cursor: 'pointer',
      FontWeight: 400,
      fontSize: typography.pxToRem(24),
      lineHeight: typography.pxToRem(32),
      textDecoration: 'underline',
      textDecorationColor: brandColors.primaryMain,
    },
    faqAnswerContainer: {
      color: brandColors.primaryMain,
      marginBottom: '0px',
      '& p': {
        marginBottom: typography.pxToRem(4),
        ...type['16_medium'],
        '&:last-child': {
          marginBottom: 0,
        },
        [breakpoints.up(ScreenSize.LARGE)]: {
          ...type['20_regular'],
        },
      },
      '& a': {
        cursor: 'pointer',
        textDecoration: 'underline',
        ...type['16_medium'],
        '&:last-child': {
          marginBottom: 0,
        },
        [breakpoints.up(ScreenSize.LARGE)]: {
          ...type['20_regular'],
        },
      },
    },
    answerTextContainer: {
      marginBottom: typography.pxToRem(24),
      '&:last-child': {
        marginBottom: 0,
      },
      wordBreak: 'break-word',
      whiteSpace: 'normal',
    },
    answerRow: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: typography.pxToRem(24),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        marginBottom: typography.pxToRem(48),
        flexDirection: 'column',
      },
    },
    answerImage: {
      width: typography.pxToRem(200),
      height: typography.pxToRem(75),
      marginRight: typography.pxToRem(78),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        marginBottom: typography.pxToRem(36),
      },
    },
    answerText: {
      maxWidth: typography.pxToRem(864),
      whiteSpace: 'pre-wrap',
    },

    faqWrapper: {
      padding: '0',
      paddingTop: typography.pxToRem(88),
      backgroundColor: brandColors.offWhite,
      marginBottom: '0',
      '& .title': {
        textAlign: 'left',
        fontSize: '20px',
        fontWeight: FontWeight.BOLD,
        color: brandColors.primaryMain,
      },
      '& .divider': {
        width: '56px',
        backgroundColor: brandColors.offWhite,
      },
      '& .MuiPaper-root': {
        boxShadow: 'none',
        border: 'none',
      },
      '& .MuiAccordion-root:before': {
        height: '0px',
      },
      '& .MuiAccordionSummary-root': {
        backgroundColor: brandColors.offWhite,
        display: 'flex',
        padding: `0 ${typography.pxToRem(40)} 0 0`,
        '& .MuiButtonBase-root': {
          padding: '0px',
          marginRight: typography.pxToRem(24),
          [breakpoints.up(ScreenSize.MEDIUM)]: {
            marginRight: typography.pxToRem(40),
          },
          [breakpoints.up(ScreenSize.LARGE)]: {
            marginRight: typography.pxToRem(36),
          },
        },
      },
      '& .MuiAccordionSummary-content': {
        padding: `0 ${typography.pxToRem(16)} 0 ${typography.pxToRem(40)}`,
        [breakpoints.up(ScreenSize.MEDIUM)]: {
          padding: 0,
        },
      },
      '& .Mui-expanded': {
        marginBottom: 0,
        marginTop: 0,
      },
    },
    OffWhiteExpanded: {
      '& .Mui-expanded': {
        backgroundColor: brandColors.offWhite,
      },
    },
    WhiteExpanded: {
      '& .Mui-expanded': {
        backgroundColor: brandColors.white,
      },
    },
    OffWhite: {
      backgroundColor: brandColors.offWhite,
    },
    White: {
      backgroundColor: brandColors.white,
    },
  })
);

export default useStyles;
